'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PRIMARY_ASSETS_CONTAINER_ID = exports.PRIMARY_ASSETS_CONTAINER_ID = 'sally-assets-primary';
var SECONDARY_ASSETS_CONTAINER_ID = exports.SECONDARY_ASSETS_CONTAINER_ID = 'sally-assets-secondary';
var ASSET_CONTAINERS = exports.ASSET_CONTAINERS = [PRIMARY_ASSETS_CONTAINER_ID, SECONDARY_ASSETS_CONTAINER_ID];

exports.default = function () {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PRIMARY_ASSETS_CONTAINER_ID;
  return document.getElementById(id);
};